/**
 * Bridge Focus Screen (Step 8)
 * "Where should we intervene first?" — Recommendation card with optional override.
 */
import React, { useState, useEffect } from 'react';
import { Card, Select, Button, Typography } from 'antd';
import {
  getProductDomainEntropyMap,
  getProductDomainSession,
} from '../../services/productDomainSessionApi';

const { Text } = Typography;

const FOCUS_OPTIONS = [
  { value: 'demand', label: 'Demand' },
  { value: 'supply', label: 'Supply' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'marketfit', label: 'MarketFit' },
  { value: 'development', label: 'Development' },
];

interface BridgeFocusScreenProps {
  sessionId: string;
  onNext: () => void;
}

export const BridgeFocusScreen: React.FC<BridgeFocusScreenProps> = ({
  sessionId,
  onNext,
}) => {
  const [entropyMap, setEntropyMap] = useState<{ bridge_focus?: string | null; highest_entropy_subdomain?: string | null } | null>(null);
  const [selectedFocus, setSelectedFocus] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const map = await getProductDomainEntropyMap(sessionId);
      setEntropyMap(map ?? null);
      setSelectedFocus(map?.bridge_focus ?? map?.highest_entropy_subdomain ?? null);
      setLoading(false);
    };
    load();
  }, [sessionId]);

  if (loading) return <div>Loading...</div>;

  const recommended = entropyMap?.bridge_focus ?? entropyMap?.highest_entropy_subdomain ?? 'demand';
  const displayRecommended = recommended ? recommended.charAt(0).toUpperCase() + recommended.slice(1) : '—';

  return (
    <div style={{ maxWidth: 600, margin: '0 auto' }}>
      <Typography.Title level={4}>Where should we intervene first?</Typography.Title>

      <Card title="Recommended Focus" style={{ marginBottom: 24 }}>
        <Text strong>Recommended Focus: {displayRecommended}</Text>
      </Card>

      <Card title="Override (optional)">
        <Select
          style={{ width: 200 }}
          placeholder="Select focus area"
          value={selectedFocus}
          onChange={setSelectedFocus}
          options={FOCUS_OPTIONS}
        />
      </Card>

      <Button type="primary" onClick={onNext} style={{ marginTop: 24 }}>
        Next
      </Button>
    </div>
  );
};
